import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseModel from "../../models/case";

export default class CaseRepository extends BaseRepository {
  static modelClass = CaseModel;
  modelName = "case";

  async getRelatableCases(id, queryParams) {
    const searchParams = queryParams ? `?${qs.stringify(queryParams)}` : "";

    return await super.query({
      urlPath: `case/${id}/relatable_cases${searchParams}`,
    });
  }

  async searchForAlternatives(caseId, providerData) {
    return super.post(providerData, {
      urlPath: `case/${caseId}/alternatives/`,
      withStatus: true,
    });
  }

  async getAddresses(caseId, queryParams = {}) {
    const searchParams = queryParams ? `?${qs.stringify(queryParams)}` : "";

    return await super.query({
      urlPath: `case/${caseId}/addresses/${searchParams}`,
    });
  }
}
